var map = {
	"./kpk-logo.png": 165,
	"./logo-ericsson.jpeg": 586,
	"./logo-exodus.jpeg": 33,
	"./logo-growth.jpeg": 464,
	"./logo-gs.svg": 350,
	"./logo-hai.jpeg": 487,
	"./logo-nmr.jpeg": 641,
	"./logo-orbitil.jpeg": 169,
	"./logo-tripstrade.svg": 824,
	"./logo-val.jpeg": 407,
	"./logo-vita.jpeg": 376,
	"./logo.png": 379,
	"./logo512.png": 612
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 709;